import { render } from "./RewardView.vue?vue&type=template&id=41260d22&scoped=true&ts=true"
import script from "./RewardView.vue?vue&type=script&lang=ts"
export * from "./RewardView.vue?vue&type=script&lang=ts"

import "./RewardView.vue?vue&type=style&index=0&id=41260d22&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41260d22"]])

export default __exports__